<template>
  <v-card class="files-save-panel">
    <div class="files-save-header">
      <v-icon small class="mr-1">mdi-content-save</v-icon>
      Save selected pages
    </div>

    <div class="files-save-body">
      <div v-if="selectedPages.length" class="mb-3">
        <div class="files-save-count mb-2">
          {{ selectedPages.length }}
          {{ selectedPages.length === 1 ? "page" : "pages" }} selected
        </div>
        <v-chip
          v-for="page in selectedPages"
          :key="page.key"
          small
          class="ma-1"
          outline
          color="success"
        >
          {{ page.fileName }} · p.{{ page.pageNumber }}
        </v-chip>
      </div>
      <div v-else class="files-save-empty">
        <v-icon class="files-save-empty-icon"
          >mdi-checkbox-blank-outline</v-icon
        >
        <div>Select pages to save.</div>
      </div>
      <div v-if="selectedPages.length">
        <div v-for="(form, index) in requirementForm" :key="index">
          <div class="files-save-label mb-2">
            <v-icon small color="success" class="mr-1"
              >mdi-file-document</v-icon
            >
            Requirement {{ index + 1 }} Document details
            <v-icon
              title="Remove requirement"
              v-if="requirementForm.length > 1"
              class="pa-0"
              @click="removeRequirement(index)"
              color="error"
              small
              style="margin-left: auto;"
              >mdi-minus-circle</v-icon
            >
          </div>
          <v-select
            :menu-props="{ maxHeight: 600 }"
            outline
            hide-details
            class="mb-3"
            label="Save as"
            :items="docTypeItems"
            v-model="form.docTypeId"
            @change="onDocTypeChange(form, index)"
          >
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title
                  :class="{ 'missing-doc-type': data.item.missingEntry }"
                >
                  {{ data.item.description }}
                </v-list-tile-title>
              </v-list-tile-content>
            </template>
            <template slot="selection" slot-scope="data">
              {{ data.item.docTypeID }}
            </template>
          </v-select>

          <v-select
            :menu-props="{ maxHeight: 600 }"
            v-if="form.docTypeId && requireStudent(form)"
            outline
            hide-details
            class="mb-3"
            label="Student"
            :items="studentItems"
            v-model="form.studentId"
          >
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ data.item.description }}
                </v-list-tile-title>
              </v-list-tile-content>
            </template></v-select
          >

          <v-text-field
            v-if="form.docTypeId == 'CH205'"
            type="date"
            outline
            hide-details
            class="mb-3"
            label="Document Date"
            v-model="form.documentDate"
          ></v-text-field>

          <v-text-field
            v-if="form.fileName"
            :readonly="true"
            filled
            flat
            hide-details
            class="mb-3"
            label="Document name"
            required
            v-model="form.fileName"
          ></v-text-field>
        </div>
        <v-btn
          color="success"
          block
          class="files-action-btn"
          @click="addRequirement"
        >
          <v-icon left small>mdi-plus-circle</v-icon>
          Add as a different requirement
        </v-btn>

        <v-btn
          color="success"
          block
          class="files-action-btn"
          :disabled="!canSave"
          :loading="saving"
          @click="save"
        >
          <v-icon left small>mdi-content-save</v-icon>
          Save document
        </v-btn>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "DocumentSplitterSavePanel",
  watch: {
    selectedPages: {
      handler(newVal) {
        if (newVal.length < 1) {
          this.requirementForm = [
            {
              studentId: "",
              docTypeId: "",
              documentDate: "",
              fileName: "",
            },
          ];
        }
      },
    },
  },
  data() {
    return {
      requirementForm: [
        {
          studentId: "",
          docTypeId: "",
          documentDate: "",
          fileName: "",
        },
      ],
    };
  },
  props: {
    accountId: {
      type: String,
      default: "",
    },
    students: {
      type: Array,
      default() {
        return [];
      },
    },
    docTypes: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedPages: {
      type: Array,
      default() {
        return [];
      },
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    studentItems() {
      const items = [];
      this.students.forEach((student) => {
        const name = student.engName || student.hebName || student.studentID;
        items.push({
          description: `${name} (${student.class})`,
          text: name,
          value: student.studentID,
        });
      });

      return items;
    },

    missingItems() {
      return this.docTypes
        .filter((type) => type.isMissing)
        .reduce((items, type) => {
          if (!type.requireStudent) {
            return items.concat({ type, student: null });
          }
          return items.concat(
            this.students
              .filter((student) =>
                this.isStudentMissingDoc(student, type.docTypeID)
              )
              .map((student) => ({
                type,
                student,
                missingDetail:
                  type.docTypeID === "IMM" ? student.missingImm : "",
              }))
          );
        }, []);
    },

    docTypeItems() {
      const allItems = this.docTypes.map((type) => ({
        ...type,
        text: type.docTypeID,
        description: this.docTypeLabel(type),
        value: type.docTypeID,
        color: "success",
      }));
      const missingItems = this.missingItems.map(
        ({ type, student, missingDetail }) => {
          const label =
            this.docTypeLabel(type) +
            (missingDetail ? ` ${missingDetail}` : "") +
            (student ? " - " + this.studentName(student) : "");
          return {
            ...type,
            text: student
              ? `${type.docTypeID} - ${this.studentName(student)}`
              : type.docTypeID,
            description: label,
            value: student
              ? type.docTypeID + "|" + student.studentID
              : type.docTypeID + "|",
            color: "error",
            missingEntry: true,
          };
        }
      );

      return missingItems.length
        ? [...missingItems, { divider: true }, ...allItems]
        : allItems;
    },

    canSave() {
      let result = true;
      this.requirementForm.forEach((form) => {
        if (
          !this.selectedPages.length ||
          this.saving ||
          !form.docTypeId ||
          !form.fileName ||
          (form.docTypeId == "CH205" && !form.documentDate) ||
          (this.requireStudent(form) && !form.studentId)
        ) {
          result = false;
        }
      });
      return result;
    },
  },

  methods: {
    requireStudent(form) {
      const result = this.docTypes.find(
        (type) => type.docTypeID === form.docTypeId
      );
      return result && result.requireStudent;
    },
    studentName(student) {
      return (
        (student &&
          (student.engName || student.hebName || student.studentID)) ||
        ""
      ).trim();
    },
    docTypeLabel(type) {
      const id = type.docTypeID;
      const desc = type.docDescription;
      return id && desc && desc !== id ? `${id} (${desc})` : desc || id;
    },
    isStudentMissingDoc(student, docTypeID) {
      return docTypeID == "IMM"
        ? student.missingImm
        : docTypeID == "CH205"
        ? student.missCH205
        : (student.skipcard || "").includes("12 GRADE APPLICATION NOT SIGNED");
    },
    onDocTypeChange(form, index) {
      this.requirementForm[index].studentId = "";
      if (form.docTypeId.split("|")[1] === "") {
        this.requirementForm[index].docTypeId = form.docTypeId.split("|")[0];
      } else if (form.docTypeId.split("|")[1]) {
        this.requirementForm[index].studentId = form.docTypeId.split("|")[1];
        this.requirementForm[index].docTypeId = form.docTypeId.split("|")[0];
      }
      this.requirementForm[index].fileName = `${this.accountId}_${
        this.requirementForm[index].docTypeId
      }`;
    },
    addRequirement() {
      this.requirementForm.push({
        studentId: "",
        docTypeId: "",
        documentDate: "",
        fileName: "",
      });
    },
    removeRequirement(requirement) {
      this.requirementForm.splice(requirement, 1);
    },
    save() {
      this.$emit("save", this.requirementForm);
    },
  },
};
</script>
<style>
.files-save-panel {
  position: sticky;
  border-radius: 8px !important;
  overflow: hidden;
}

.files-save-header {
  display: flex;
  align-items: center;
  background: #4caf50;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 16px;
}

.files-save-header .v-icon {
  color: #fff !important;
}

.files-save-body {
  padding: 16px;
}

.files-save-count {
  font-size: 12px;
  font-weight: 700;
  color: #4caf50;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.files-save-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  color: #4caf50;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.files-save-empty {
  text-align: center;
  color: #9e9e9e;
  padding: 24px 8px 8px;
  font-size: 13px;
}

.files-save-empty-icon {
  display: block;
  font-size: 36px !important;
  color: #c8e6c9 !important;
  margin-bottom: 8px;
}

.files-action-btn {
  text-transform: none !important;
  font-weight: 700 !important;
  border-radius: 8px !important;
  margin-top: 4px;
}

.missing-doc-type {
  color: #f44336 !important;
}
</style>
